import { Type } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import {
  AbstractFeatureGitService,
  AbstractFeatureGitServiceHydrationDefinition,
  getY42GitPath,
} from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { DatasourceLike, DatasourceSettings, DatasourceStoreModel } from './datasource.model';

export abstract class DatasourceGitService extends AbstractFeatureGitService<DatasourceStoreModel, DatasourceLike> {
  constructor(
    protected readonly datasourceConfig: {
      name: 'Integration' | 'Model';
      type: DatasourceLike;
      git: GitService;
      errorHandlerService: ErrorHandlerService;
      hydrationDefinition: AbstractFeatureGitServiceHydrationDefinition;
      gitQuery: GitQuery;
      settingsGitModel: Type<DatasourceSettings>;
    },
  ) {
    super({
      ...datasourceConfig,
      basePath: getY42GitPath(datasourceConfig.type),
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: datasourceConfig.settingsGitModel,
        },
      },
    });
  }

  readonly getCredentialsPath = (id: DatasourceStoreModel['$name']) => this.getPath(id, '.y42/secret.enc');

  async deleteDatasourceAuthorization(datasourceId: DatasourceStoreModel['$name']) {
    const credentialsPath = this.getCredentialsPath(datasourceId);
    await this.gitClient.deleteFile({ path: credentialsPath });
    await this.gitClient.commit('Revoke Access', [credentialsPath]);
  }
}
